export const white = '#ffffff';
export const black = '#1f2122';
export const blueGrey = '#636e72';
export const lightGrey = '#b2bec3';
export const whiteGrey = '#f3f7fa';
export const paleBlueGrey = '#e4eaef';
export const historyBg = '#2c2e30';
export const pinkRed = '#ff005c';
export const blue = '#001aff';
